import React, {useEffect, useMemo, useRef, useState} from "react";
import styled from "styled-components";
import _ from "lodash";
import {useSelector} from "react-redux";

const FadeInBox = styled.div`
  width: 304px;
  height: 350px;
  animation: fadein 1s linear;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;


// 1 = LRZ 클랜
// 2 = U4
// 3 = 서라벌 떡방
// 4 = 메디텍고
// 5 = 스쿼드 클랜
// 6 = LRZ  클랜
// 98 = 딥롤 광고1
// 99 = 딥롤 광고2
const Adcalc = (value) => {
    if (value <= 300) {
        return 6
    } else if (value <= 600) {
        return 5
    } else if (value <= 800) {
        return 98
    }
    return 99
    //
    // if (value <= 300) {
    //     return 1
    // } else if (value <= 400) {
    //     return 2
    // } else if (value <= 700) {
    //     return 5
    // } else if (value <= 850) {
    //     return 98
    // }
    // return 99
};

const randomNumber100 = () => {
    return _.random(1, 1000);
}
const SmallBannerAd = () => {
    const currentLang = useSelector((state) => state.translation.lang);

    // const [adState, setAdState] = useState(() => {
    //     return Adcalc(randomNumber100())
    // });
    //
    //
    // const changeState = () => {
    //     setAdState(prev => {
    //         let result = prev;
    //         while (true) {
    //             if (result !== prev) {
    //                 break;
    //             } else {
    //                 result = Adcalc(randomNumber100());
    //             }
    //         }
    //         return result
    //     })
    // }
    //
    if(currentLang === 'ja') {
        return <JPAd/>
    }

    if (currentLang !== 'KOR') {
        return <OtherAd/>
    }
    return null

}


const TimeBox = () => {
    const time = useMemo(() => {
        const date = new Intl.DateTimeFormat('en', {
            timeZone: 'Asia/Seoul',
            hour12: false,
            hour: '2-digit'
        }).format(new Date());
        return Number(date)
    }, []);

    const href = useMemo(() => {
        if (time > 2 && time < 18) {
            return "https://www.youtube.com/shorts/7XUrRjSMNCg"
        } else {
            return "https://chzzk.naver.com/eb509a24d92170db1ba9bafb58696be0"
        }
    }, [time]);


    return (
        <FadeInBox>
            <a href={href} target={'_blank'}>
                <img src={'./images/ad/ad_state3.png'} width={'100%'} height={120} alt={''}
                />
            </a>
        </FadeInBox>
    )
}

const TimeOutBox = ({time, changeState, children}) => {
    const [isFocused, setIsFocused] = useState(true);
    const timeoutRef = useRef(0);

    const TimeoutBoxSetTimeout = () => {
        return setTimeout(() => {
            changeState();
        }, time)
    }

    useEffect(() => {
        if (isFocused) {
            timeoutRef.current = TimeoutBoxSetTimeout();
        } else if (!isFocused && timeoutRef.current) {
            clearTimeout(timeoutRef.current)
        }
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }
        }
    }, [isFocused])


    useEffect(() => {
        const handleFocusChange = () => {
            setIsFocused(document.hasFocus());
        };

        window.addEventListener("focus", handleFocusChange);
        window.addEventListener("blur", handleFocusChange);

        // 컴포넌트 언마운트 시 이벤트 제거
        return () => {
            window.removeEventListener("focus", handleFocusChange);
            window.removeEventListener("blur", handleFocusChange);
        };
    }, []);


    return children
}

// 총 9개
const OtherAdCalc = (value) => {
    return 1
}

const OtherAd = () => {
    const [adState, setAdState] = useState(() => {
        return OtherAdCalc(randomNumber100())
    });

    const changeState = () => {
        setAdState(prev => {
            // let result = prev;
            let result = 1
            // while (true) {
            //     if (result !== prev) {
            //         break;
            //     } else {
            //         result = OtherAdCalc(randomNumber100());
            //     }
            // }
            return result
        })

    }
    if ([1].includes(adState)) {
        return (
            <TimeOutBox key={adState + "adState1en"} time={10000} changeState={changeState}>
                <FadeInBox>
                    <a href={'https://www.mobatrainer.com/puzzle-of-the-day?utm_source=website&utm_medium=banner&utm_campaign=DEEP20_Hardstuck'}
                       target={'_blank'} id={'add_to_Banner_4'}>
                        <img src={'./images/ad/mobatrainer/small/final2_small.png'} width={'100%'}  alt={''} height={350}
                        />
                    </a>
                </FadeInBox>
            </TimeOutBox>
        )
    }





    return <TimeOutBox key={adState + "adState9en"} time={10000} changeState={changeState}>
        <FadeInBox>
            <a href={'https://www.mobatrainer.com/puzzle-of-the-day?utm_source=website&utm_medium=banner&utm_campaign=DEEP20_Hardstuck'}
               target={'_blank'} id={'add_to_Banner_4'}>
                <img src={'./images/ad/mobatrainer/small/final2_small.png'} width={'100%'}  alt={''} height={350}
                />
            </a>
        </FadeInBox>
    </TimeOutBox>
}


const JpAdCalc = (value) => {
    return 1
}

const JPAd = () => {
    const [adState, setAdState] = useState(() => {
        return JpAdCalc(randomNumber100())
    });

    const changeState = () => {
        setAdState(prev => {
            let result = 1;
            // while (true) {
            //     if (result !== prev) {
            //         break;
            //     } else {
            //         result = JpAdCalc(randomNumber100());
            //     }
            // }
            return result
        })

    }
    if ([1].includes(adState)) {
        return (
            <TimeOutBox key={adState + "adState1jp"} time={10000} changeState={changeState}>
                <FadeInBox>
                    <a href={'https://www.mobatrainer.com/puzzle-of-the-day?utm_source=website&utm_medium=banner&utm_campaign=DEEP20_Hardstuck_JP'}
                       target={'_blank'} id={'add_to_Banner_6'}>
                        <img src={'./images/ad/mobatrainer/small/final2_small_jp.png'} width={'100%'}  alt={''} height={350}
                        />
                    </a>
                </FadeInBox>
            </TimeOutBox>
        )
    }





    return <TimeOutBox key={adState + "adState9jp"} time={10000} changeState={changeState}>
        <FadeInBox>
            <a href={'https://www.mobatrainer.com/puzzle-of-the-day?utm_source=website&utm_medium=banner&utm_campaign=DEEP20_Hardstuck_JP'}
               target={'_blank'} id={'add_to_Banner_6'}>
                <img src={'./images/ad/mobatrainer/small/final2_small_jp.png'} width={'100%'}  alt={''} height={350}
                />
            </a>
        </FadeInBox>
    </TimeOutBox>
}



export default SmallBannerAd